module.exports = __webpack_public_path__ + "img/it-23.2dd6f903.svg";